import { StyleSheet } from 'react-native';
import { fontFamily, fontSizeSmall } from '../../../constants/palette';

export default StyleSheet.create({
  container: {
    marginBottom: 10,
  },
  feedbackContainer: {
    flexDirection: 'row',
  },
  thankYouContainer: {
    alignItems: 'center',
  },
  thankYouText: {
    fontSize: fontSizeSmall,
  },
  thumbsContainer: {
    flexDirection: 'column',
    paddingRight: 5,
  },
  text: {
    fontFamily,
  },
});
